import { MessageService } from "./shared/services/message.service";
import { CustomerService } from "./shared/services/customer.service";
import {
	APP_INITIALIZER,
	CUSTOM_ELEMENTS_SCHEMA,
	ErrorHandler,
	LOCALE_ID,
	NgModule,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SocketIoModule } from "ngx-socket-io";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ToastrModule } from "ngx-toastr";
import { AlertService } from "@shared/services/alert.service";
import localePt from "@angular/common/locales/pt";
import { registerLocaleData } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "@core/services/auth.interceptor";
import { SocketService } from "@core/services/socket.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
// import * as Sentry from "@sentry/angular-ivy";
import { Router } from "@angular/router";
import { AppConfigService } from "./configs/app-config.service";
import { MarkdownModule } from 'ngx-markdown';

registerLocaleData(localePt, "pt-BR");

export function initApp(appConfig: AppConfigService) {
	return () => appConfig.loadConfig();
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		FormsModule,
		ReactiveFormsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		BrowserAnimationsModule,
		SocketIoModule,
		NgbModule,
		NgxSpinnerModule,
		MarkdownModule.forRoot(),
	],
	providers: [
		// {
		//   provide: ErrorHandler,
		//   useValue: Sentry.createErrorHandler({
		//     showDialog: false,
		//   }),
		// },
		// {
		//   provide: Sentry.TraceService,
		//   deps: [Router],
		// },
		// {
		//   provide: APP_INITIALIZER,
		//   useFactory: () => () => {},
		//   deps: [Sentry.TraceService],
		//   multi: true,
		// },
		MessageService,
		CustomerService,
		AlertService,
		AuthInterceptor,
		{ provide: LOCALE_ID, useValue: "pt-BR" },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		SocketService,
		AppConfigService,
		{
			provide: APP_INITIALIZER,
			useFactory: initApp,
			deps: [AppConfigService],
			multi: true,
		},
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
